import type { InputHTMLAttributes } from "react"
import { useId } from "react"
import { mergeClasses } from "../../../../utils/css"
import "./InputToggle.scss"

export enum ToggleSize {
    Small = "ToggleSize-small",
    Medium = "ToggleSize-medium",
}

interface InputToggleProps extends InputHTMLAttributes<HTMLInputElement> {
    checked: boolean
    onToggle: (isOn: boolean) => void
    className?: string
    name?: string
    toggleSize?: ToggleSize
}

export function InputToggle({
    checked,
    onToggle,
    className,
    name,
    toggleSize = ToggleSize.Medium,
    ...props
}: InputToggleProps) {
    const uniqueId = useId()
    return (
        <div className={mergeClasses("InputToggle", className, toggleSize)}>
            <label
                className="InputToggle__switch"
                htmlFor={`InputToggle__checkbox_${uniqueId}`}
            >
                <input
                    type="checkbox"
                    id={`InputToggle__checkbox_${uniqueId}`}
                    onChange={(e) => onToggle(e.target.checked)}
                    checked={checked}
                    name={name}
                    {...props}
                />
                <div className="InputToggle__slider round" />
            </label>
        </div>
    )
}
